import { useCallback, useEffect, useMemo } from 'react';
import { auditsStore, resetAuditFilters, setAuditFilters } from '../store/auditsStore';
import {
  dashboardStore,
  managementWorkspaceStore,
} from '../store/workspaceStore';

function useExternalStoreResource(store, params) {
  const snapshot = store.useStore((value) => value);
  const paramsKey = JSON.stringify(params || {});

  useEffect(() => {
    // The store owns the request lifecycle and exposes failures through its
    // snapshot.  Consume the rejection here to avoid duplicate console noise.
    store.load(params).catch(() => {});
  }, [store, paramsKey]);

  return {
    data: snapshot.data,
    loading: !!snapshot.loading,
    error: snapshot.error || '',
    reload: () => store.load(params, { force: true }),
  };
}

export function useDashboard() {
  return useExternalStoreResource(dashboardStore);
}

export function useAudits(filters) {
  const storeState = auditsStore.useStore((value) => value);
  const effectiveFilters = useMemo(() => ({ 
    ...(storeState.filters || {}), 
    ...(filters || {}) 
  }), [storeState.filters, filters]);
  
  const resource = useExternalStoreResource(auditsStore, effectiveFilters);
  
  const setFiltersStable = useCallback((newFilters) => {
    setAuditFilters(newFilters);
  }, []);

  const resetFiltersStable = useCallback(() => {
    resetAuditFilters();
  }, []);

  return {
    ...resource,
    filters: effectiveFilters,
    setFilters: setFiltersStable,
    resetFilters: resetFiltersStable,
  };
}

export function useManagementWorkspace() {
  return useExternalStoreResource(managementWorkspaceStore);
}
